import { Link, useParams } from 'react-router-dom';
import { usePastWeek } from '../api/planner';
import PlanEntryCard from '../components/PlanEntryCard';
import { weekLabel } from '../weeks';

/** One week that has already happened, and nothing that could change it.
 *
 * There is no read-only flag here. The controls the plan screen offers are
 * passed into PlanEntryCard as a slot, so this page is read-only by having
 * nothing to pass rather than by remembering to hide anything -- which is
 * what stops the next button added to the current week from appearing here
 * uninvited.
 *
 * No shopping list and no prices either. Both are built from today's shelf
 * prices and today's cupboard, so against a finished week they would not be
 * a record of anything.
 */
export default function PastWeek() {
  const { week } = useParams();
  const { data, isLoading } = usePastWeek(week);
  const plan = data?.results?.[0];

  if (isLoading) return <p className="center-note">Loading that week…</p>;

  if (!plan) {
    return (
      <section>
        <Link className="link-button" to="/history">
          ← Past weeks
        </Link>
        <h1>That week isn’t here</h1>
        <p className="muted">
          Only weeks you chose a plan for are kept, and only once the week is
          over.
        </p>
      </section>
    );
  }

  return (
    <section>
      <Link className="link-button" to="/history">
        ← Past weeks
      </Link>

      <h1>Week of {weekLabel(plan.week_start)}</h1>
      <p className="muted small">Cooked from {plan.store}</p>

      {plan.generation_notes && (
        <p className="plan-summary">{plan.generation_notes}</p>
      )}

      <ol className="plan-list">
        {plan.entries.map((entry) => (
          <PlanEntryCard key={entry.id} entry={entry} />
        ))}
      </ol>
    </section>
  );
}
